<template>
  <div class="home">
    <section class="section">
      <div class="container">
          <h1>Dashboard</h1>
          <p>This page will be a dashboard in someday. 🤣🤣</p>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: 'home',
};
</script>
